var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"ball",staticClass:"float-ball",class:{ 'dragging': _vm.dragging },style:(_vm.ballStyle),on:{"mousedown":function($event){$event.stopPropagation();return _vm.startDrag.apply(null, arguments)},"touchstart":function($event){$event.stopPropagation();return _vm.handleTouchStart.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }